import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { loader as gqlLoader } from 'graphql.macro';
import GraphQLData from '../lib/GraphQLData';
import Header from '../components/navigation/Header';
import Footer from '../components/navigation/Footer';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { DotLottiePlayer } from '@dotlottie/react-player';

const NotFoundQuery = gqlLoader('./NotFound.graphql');

const NotFound = (props) => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const desktopVideoRef = useRef(null);
  const mobileVideoRef = useRef(null);

  useEffect(() => {
    // Scroll to top and set initial body class
    window.scrollTo(0, 0);
    document.body.classList.add('error_loader');

    const handleVideoEnd = () => {
      document.body.classList.remove('error_loader');
      document.body.classList.add('video_loaded');
      setVideoLoaded(true);
    };

    // Add video ended event listeners
    if (desktopVideoRef.current) desktopVideoRef.current.addEventListener('ended', handleVideoEnd);
    if (mobileVideoRef.current) mobileVideoRef.current.addEventListener('ended', handleVideoEnd);

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('error_loader');
      document.body.classList.remove('video_loaded');
      if (desktopVideoRef.current) {
        desktopVideoRef.current.removeEventListener('ended', handleVideoEnd);
      }
      if (mobileVideoRef.current) {
        mobileVideoRef.current.removeEventListener('ended', handleVideoEnd);
      }
    };
  }, []);

  useEffect(() => {
    if (desktopVideoRef.current && props?.notfound?.item?.VideoPoster?.url) {
      desktopVideoRef.current.load();
    }
    if (mobileVideoRef.current && props?.notfound?.item?.VideoPosterMobile?.url) {
      mobileVideoRef.current.load();
    }
  }, [props?.notfound?.item?.VideoPoster?.url, props?.notfound?.item?.VideoPosterMobile?.url]);

  return (
    <>
      <Helmet>
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/bootstrap.min.css" media="all" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/swiper-bundle.min.css"
          media="all"
        />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/aos.css" media="all" />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/15.7.1/nouislider.css"
        />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/common.css" media="all" />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/style.css" media="all" />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/navigation.css" media="all" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/categorypage-style.css"
          media="all"
        />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/enquiry-now.css" media="all" />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/tax-planning.css" media="all" />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/abc_footer.css" media="all" />
        <link rel="stylesheet" type="text/css" href="https://abconeprod.azureedge.net/dist/ABCD/assets/css/jss-override.css" media="all" />
      </Helmet>
      <div className="ticker-header-parent ticker-notfound">
        <Header />
      </div>
      <div id="videoLoader">
        {props?.notfound?.item?.VideoPoster?.url.split('.').pop() === 'lottie' ||
        props?.notfound?.item?.VideoPoster?.url.split('.').pop() === 'json' ? (
          <DotLottiePlayer
            className="loaderVideo desk_banner hidden-xs hidden-sm"
            src={props?.notfound?.item?.VideoPoster?.url}
            background="transparent"
            speed={1}
            autoplay
            loop
          ></DotLottiePlayer>
        ) : (
          <video
            ref={desktopVideoRef}
            className="loaderVideo desk_banner hidden-xs hidden-sm"
            poster={props?.notfound?.item?.ImagePoster?.src}
            autoPlay
            muted
            playsInline
            width={props?.notfound?.item?.ImagePoster?.width}
            height={props?.notfound?.item?.ImagePoster?.height}
          >
            <source src={props?.notfound?.item?.VideoPoster?.url} type="video/mp4" />
          </video>
        )}

        {props?.notfound?.item?.VideoPosterMobile?.url.split('.').pop() === 'lottie' ||
        props?.notfound?.item?.VideoPosterMobile?.url.split('.').pop() === 'json' ? (
          <DotLottiePlayer
            className="loaderVideo mob_banner hidden-lg hidden-md"
            src={props?.notfound?.item?.VideoPosterMobile?.url}
            background="transparent"
            speed={1}
            autoplay
            loop
          ></DotLottiePlayer>
        ) : (
          <video
            ref={mobileVideoRef}
            className="loaderVideo mob_banner hidden-lg hidden-md"
            poster={props?.notfound?.item?.ImagePosterMobile?.src}
            autoPlay
            muted
            playsInline
            width={props?.notfound?.item?.ImagePosterMobile?.width}
            height={props?.notfound?.item?.ImagePosterMobile?.height}
          >
            <source src={props?.notfound?.item?.VideoPosterMobile?.url} type="video/mp4" />
          </video>
        )}
      </div>
      <div className="cus-container">
        <div className="main_error_wrapper">
          <div className="error_col_center">
            <h1>{props?.notfound?.item?.Heading?.value}</h1>
            <p>{props?.notfound?.item?.SubHeading?.value}</p>
            <div className="error_btn_Wrapper">
              <a
                href={props?.notfound?.item?.CTALinkLeft?.url}
                className="know_more_about-us border_btn"
              >
                {props?.notfound?.item?.CTALinkLeft?.text}
              </a>
              <a
                href={props?.notfound?.item?.CTALinkRight?.url}
                className="know_more_about-us error_solid_btn"
              >
                {props?.notfound?.item?.CTALinkRight?.text}
                <img src={props?.notfound?.item?.ImagePlayStore?.src} />
                <img src={props?.notfound?.item?.ImageAppStore?.src} />
              </a>
            </div>
            <img
              src={props?.notfound?.item?.ImageError?.src}
              className="error_image_Wrapper hidden-xs hidden-sm"
            />
            <img
              src={props?.notfound?.item?.ImageErrorMobile?.src}
              className="error_image_Wrapper hidden-lg hidden-md"
            />
          </div>

          <div className="errorBoxesWrapper errorBoxesWrapper--s2">
            <div className="errorBox">
              {props?.notfound?.item?.ContentListLeft?.targetItems.map((content, index) => (
                <div className="errorBoxCard" key={index}>
                  <div className={`errorCardContent bg${index + 1}`}>
                    <div className="errorcardheading">
                      <Text tag="h5" className="headingcardhtag" field={content?.Heading} />
                    </div>
                    <RichText tag="ul" className="errorLists" field={content?.Text} />
                    <div className="errorcardVector">
                      <img
                        src={content?.Icon?.src}
                        className=""
                        alt={content?.Icon?.alt}
                        width={content?.Icon?.width}
                        height={content?.Icon?.height}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="errorBox">
              {props?.notfound?.item?.ContentListRight?.targetItems.map((content, index) => (
                <div className="errorBoxCard" key={index}>
                  <div className={`errorCardContent bg${index + 1}`}>
                    <div className="errorcardheading">
                      <Text tag="h5" className="headingcardhtag" field={content?.Heading} />
                    </div>
                    <RichText tag="ul" className="errorLists" field={content?.Text} />
                    <div className="errorcardVector">
                      <img
                        src={content?.Icon?.src}
                        className=""
                        alt={content?.Icon?.alt}
                        width={content?.Icon?.width}
                        height={content?.Icon?.height}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <footer className="footer-section"></footer>
    </>
  );
};

export default GraphQLData(NotFoundQuery, { name: 'notfound' })(NotFound);
